import { useCallback, useEffect, useState } from 'react';
import {
  tryClosePaymentWindow,
  wasCloseLikelyBlocked,
} from '../../core/close-payment-window';
import { showSuccess } from '../../core/utils';

const AUTO_CLOSE_MS = 5000;

export default function StandalonePaymentCloseOverlay({ refId }: { refId?: string }) {
  const [countdown, setCountdown] = useState(5);
  const [closeBlocked, setCloseBlocked] = useState(false);

  const attemptClose = useCallback(() => {
    tryClosePaymentWindow(refId);
    window.setTimeout(() => {
      if (wasCloseLikelyBlocked()) {
        setCloseBlocked(true);
      }
    }, 400);
  }, [refId]);

  useEffect(() => {
    showSuccess('Thanh toán thành công!', { duration: AUTO_CLOSE_MS });
    const tick = window.setInterval(() => {
      setCountdown((prev) => Math.max(0, prev - 1));
    }, 1000);
    const closeTimer = window.setTimeout(attemptClose, AUTO_CLOSE_MS);
    return () => {
      window.clearInterval(tick);
      window.clearTimeout(closeTimer);
    };
  }, [attemptClose]);

  return (
    <div className="standalone_payment_overlay" role="dialog" aria-modal="true">
      <div className="standalone_payment_dialog">
        <h2>Thanh toán thành công</h2>
        {closeBlocked ? (
          <p>
            Trình duyệt không cho phép tự đóng tab này. Vui lòng bấm nút bên dưới hoặc đóng tab thủ công và quay lại game.
          </p>
        ) : (
          <p>Giao dịch đã hoàn tất. Cửa sổ thanh toán sẽ tự đóng sau {countdown} giây.</p>
        )}
        <button type="button" className="primary_btn" onClick={attemptClose}>
          Tắt thanh toán
        </button>
      </div>
    </div>
  );
}
